import { render } from "./ListWorkspace.vue?vue&type=template&id=322c1e82&scoped=true&ts=true"
import script from "./ListWorkspace.vue?vue&type=script&lang=ts"
export * from "./ListWorkspace.vue?vue&type=script&lang=ts"

import "./ListWorkspace.vue?vue&type=style&index=0&id=322c1e82&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322c1e82"]])

export default __exports__